<template>
	<div
		:style="{
			'flex-direction': $vuetify.breakpoint.smAndUp ? 'row' : 'column',
			overflow: $vuetify.breakpoint.smAndUp ? 'hidden' : 'auto'
		}"
		class="markdown-container"
	>
		<div :style="{ width: $vuetify.breakpoint.smAndUp ? '50%' : '100%' }" class="markdown-editor-container">
			<div class="pt-2 pb-1 text-xs-center primary">
				<v-menu
					v-for="(option, index) in markdownOptions"
					:key="index"
					bottom
				>
					<v-btn slot="activator" flat small dark>
						{{ option.name }}
					</v-btn>
					<v-list>
						<v-list-tile
							v-for="(item, index) in option.options"
							:key="index"
							@click="addAttribute(item.markdown)"
						>
							<v-list-tile-title>{{
								item.name
							}}</v-list-tile-title>
						</v-list-tile>
					</v-list>
				</v-menu>
			</div>
			<textarea ref="markdown" />
		</div>
		<v-divider vertical />
		<div :style="{ width: $vuetify.breakpoint.smAndUp ? '50%' : '100%' }">
			<!-- <MarkdownPreview :value="previewValue"/> -->
			<!-- <textarea ref="preview" /> -->
			<div :class="{ 'frame-blur': previewLoading, 'iframe-container': true }">
				<iframe
					id="frame"
					:srcdoc="frameHtml"
					src=""
					@load="$emit('preview-loading', false); previewLoading = false"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import _ from 'lodash';
import * as SimpleMDE from 'simplemde/dist/simplemde.min';
// import MarkdownPreview from '@/components/MarkdownPreview';
import StoreMethods from '@/mixins/StoreMethods';
import Twig from 'twig';
import axios from 'axios';

export default {
	// components: {
	// 	MarkdownPreview,
	// },
	mixins: [StoreMethods],
	props: {
		value: { type: String, default: '' },
		article: { type: Object, default: null },
		report: { type: Object, default: null },
		publications: { type: Array, default: null },
		articleRelated: { type: Boolean, default: true },
		outputPreview: { type: String, default: ''},
		outputKey: { type: String, default: ''},
	},
	data() {
		return {
			twig: Twig,
			markdown: null,
			//preview: null,
			//previewValue: '',
			previewLoading: false,
			templateRegex: /\{(.*?)\}/g,
			templateReplaceRegex: /[{}]/g,
			articles: null,
			pubLogoBaseURL: 'https://logo.clearbit.com/',
			frameHtml: '',
			toolbar: ['heading-1', 'heading-2', 'heading-3', '|', 'bold', 'italic', 'strikethrough', '|',
				'unordered-list', 'ordered-list', '|', 'link', 'horizontal-rule',
				{
					name: 'fullscreen',
					action: SimpleMDE.toggleFullScreen,
					className: 'toolbar-item--hidden',
					title: 'Full',
				},
				{
					name: 'side-by-side',
					action: SimpleMDE.toggleSideBySide,
					className: 'toolbar-item--hidden',
					title: 'Side',
				},
			],
		};
	},
	computed: {
		baseURL() {
			return process.env.VUE_APP_OUTPUT_ROOT;
		},
		markdownOptions() {
			if (this.articleRelated) {
				return this.$store.get('markdownOptions');
			}
			return this.$store.get('markdownOptions').filter(option => !option.articleRelated);
		},
	},
	watch: {
		article(newVal, oldVal) {

			this.updatePreview();
		},
	},
	mounted() {
		this.markdown = new SimpleMDE({
			element: this.$refs.markdown,
			autoDownloadFontAwesome: false,
			status: false,
			spellChecker: false,
			toolbar: this.toolbar,
			placeholder: "Your markdown content here. \n\rIf empty, default markdown will be used (see preview on the right screen).",
		});

		this.markdown.codemirror.on('change', () => {
			const value = this.markdown.value();
			this.$emit('input', value);
		});

		// Allow SimpleMDE to setup before adding markdown or else text cursor is very wonky
		setTimeout(() => {
			this.markdown.value(this.value);
			this.markdown.codemirror.on('change', _.debounce(this.updatePreview, 2000));
		}, 400);
	},
	methods: {
		updatePreview() {
			var t = this;
			t.previewLoading = true;
			t.$emit('preview-loading', true);
			const url = `${this.baseURL}/print/preview`;
			const data = {
				article_id: null,
				preview: t.outputPreview,
				key: t.outputKey,
				code: t.markdown.value(),
			};

			if (t.outputPreview === 'article_index' || t.outputPreview === 'article_body')
				data.article_id = t.article.id;

			axios.post(url, data, {
				headers: {'X-Requested-With': 'XMLHttpRequest'}
			}).then((r) => {
				t.frameHtml = r.data.replace(/(href|src)=("|')\//g, '$1=$2' + t.baseURL + '/');
			}).catch((e) => {
				dump('Error updating preview', e);
			});

			// const value = this.markdown.value();
			// try {
			// 	const template = Twig.twig({ data: value, rethrow: true });
			// 	const render = template.render({
			// 		article: this.twigArticle,
			// 		publication: this.twigPublication,
			// 		pub: this.twigPublication, // temp fix until db update, remove after that
			// 		report: this.twigReport,
			// 		project: this.twigProject,
			// 	});
			// 	const previewItem = document.getElementsByClassName('editor-preview');
			// 	previewItem[0].innerHTML = this.preview.options.previewRender(render, previewItem[0]);
			// }
			// catch (error) {
			// 	// Don't update preview if there is an error.
			// }
		},
		addToEditor(attribute, editor) {
			const cm = editor.codemirror;
			const output = attribute;

			cm.replaceSelection(output);
		},
		addAttribute(attribute) {
			if (!this.markdown) {
				return;
			}
			this.addToEditor(attribute, this.markdown);
		},
	},
};
</script>

<style lang="scss">
.markdown-container {
	@import "~simplemde/dist/simplemde.min";
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	.markdown-editor-container {
		display: flex;
		flex-direction: column;
	}
	.toolbar-item--hidden {
		visibility: hidden;
		min-width: 0px !important;
		min-width: 0px !important;
		height: 0px !important;
	}
}
.editor-toolbar {
	display: flex;
	justify-content: center;
	text-align: center !important;
	width: 100% !important;
	border: none !important;
	border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
	opacity: 1 !important;
	&::after {
		margin: 0 !important;
	}
	&::before {
		margin: 0 !important;
	}
	a {
		width: auto !important;
		min-width: 30px;
		&:hover {
			border-color: transparent !important;
		}
	}
	a.active {
		border-color: transparent !important;
		color: #1d97c1 !important;
	}
}
.custom-toolbar-item:before {
	content: attr(title);
	width: 100px;
	margin: 0 3px;
}
.CodeMirror {
	border: none !important;
	width: 100%;
	flex-grow: 1;
	// height: 100% !important;
	// min-height: 100% !important;
}
.editor-preview {
	img {
		max-width: 100% !important;
	}
}
.iframe-container {
	height: 100%;
	&.frame-blur {
		filter: blur(10px); /*  this is not compatible with IE */
		transition: -webkit-filter 100ms ease-in-out;
	}
	iframe {
		width: 100%;
		height: 100%;
		border: none;
		display: block;
	}
}
</style>
